import { StateCreator } from "zustand";

export interface ModalSlice {
  modalVisible: boolean;
  modalType: string;
  setModalType: (modalType: string) => void;
  toggleModalVisible: () => void;
}

export const createModalSlice: StateCreator<ModalSlice> = set => ({
  modalVisible: false,
  modalType: "",
  setModalType: modalType => set(() => ({ modalType })),
  toggleModalVisible: () =>
    set(state => ({ modalVisible: !state.modalVisible })),
});
